import React, {} from "react";
import {
    daysBetween,
    getDefaultPaymentMethod,
    getFormattedMessage,
    openTermDetailsPage
} from "../../../../helpers/helpers";
import GenericButton from "../../../common/buttons/GenericButton";
import {AC_DEV_LEVEL, AC_PAGES, PAYMENT_TYPE, SUBSCRIPTION_ROOT_PAGES} from "../../../../constants";
import GenericItem from "../../../common/items/GenericItem";
import {Settings} from "../../../../models/models";
import BackButton from "../../../common/buttons/BackButton";

const getAccountDetailsInfoText = (isAdmin, daysUntilExpired, last4, isBasic, doNotRenew) => {
    if (isAdmin || isBasic) {
        return i18n.payments.ac.doesNotExpire;
    }

    let infoText;
    if (daysUntilExpired > 0) {
        infoText = getFormattedMessage(i18n.payments.ac.daysUntilExpired, daysUntilExpired + 1);
        if (doNotRenew) {
            infoText += ` ${i18n.payments.ac.setToNotRenew}`;
        } else if (last4) {
            infoText += ` ${i18n.payments.ac.scheduledToRenew}`;
        } else {
            infoText += ` ${i18n.payments.ac.pleaseAttachPaymentMethod}`;
        }
    } else if (daysUntilExpired === 0) {
        infoText = i18n.payments.ac.expiresToday;
        if (doNotRenew) {
            infoText += ` ${i18n.payments.ac.setToNotRenew}`;
        } else if (last4) {
            infoText += ` ${i18n.payments.ac.scheduledToRenewToday}`;
        } else {
            infoText += ` ${i18n.payments.ac.pleaseAttachPaymentMethodExpiresToday}`;
        }
    } else {
        if (last4) {
            return i18n.payments.ac.hasExpiredWithPaymentMethod;
        } else {
            return i18n.payments.ac.hasExpiredWithoutPaymentMethod;
        }
    }

    return infoText;
}

const AcSplashPage = (props: {
    settings: Settings,
    setPage: Function,
    setPayNow: Function,
    setRootPage: Function
}) => {
    const {appCenterData, settings, setPage, setPayNow, setRootPage} = props;

    const {isAdmin} = settings || {};

    const {expirationDate, devLevel, doNotRenew, allPaymentMethods} = appCenterData || {};

    const paymentMethod = getDefaultPaymentMethod(allPaymentMethods);
    const { last4, paymentMethodId, expDate } = paymentMethod;

    const daysUntilExpired = daysBetween(new Date(), new Date(expirationDate));
    const isBasic = devLevel === AC_DEV_LEVEL.BASIC;
    const showCardItem = !isBasic;
    const showPayNow = daysUntilExpired <= 90;

    const onManageClick = () => {
        setPage(AC_PAGES.MANAGE);
    };

    const onPayNowClick = () => {
        setPayNow(true);
        setPage(AC_PAGES.PLAN_DETAILS);
    };

    const onTermsClick = () => {
        openTermDetailsPage(PAYMENT_TYPE.AC);
    };

    const infoText = getAccountDetailsInfoText(isAdmin, daysUntilExpired, paymentMethodId, isBasic, doNotRenew);

    let Body = (
        <div className={"row"} data-testid={'acSplashPage'}>
            <div className={"col-12"}>
                <GenericItem title={i18n.common.details}
                             details={infoText}/>

                <div className={'row'}>
                    {
                        showCardItem && paymentMethodId && (
                            <div className={'plan-payment-method-card'} data-testid={'planPaymentMethodCardDiv'}>
                                <div className={'plan-sub-title'}>
                                    Active Card:
                                </div>
                                <div className={'plan-sub-details'}>
                                    **** **** **** {last4}
                                </div>
                                <div className={'plan-sub-details'}>
                                    {i18n.payments.expires} {expDate}
                                </div>
                            </div>
                        )
                    }
                </div>

                <div className={`flexSpaceBetween`}>
                    <div className={`flex margin-top-1`}>
                        <BackButton onClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.HOME)}/>
                        <GenericButton onClick={onManageClick}
                                       testid={'manageBtn'}
                                       text={i18n.payments.manage}/>

                        {showPayNow
                            && <GenericButton onClick={onPayNowClick}
                                              testid={'payNowBtn'}
                                              cssClasses={`margin-left-1`}
                                              text={i18n.payments.payNow}/>}
                    </div>
                    <GenericButton onClick={onTermsClick}
                                   testid={'termsBtn'}
                                   cssClasses={`margin-left-1 button-gray`}
                                   text={i18n.payments.terms}/>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            {Body}
        </div>
    );
}

export default AcSplashPage;